<div id="app-comp" [class.add-v1-css]="!enableLeftPanelView" [class.restrictBackgroundScroll]="openModalFlag">
  @if (isLoggedIn || isProfileAvailable) {
    <header id="amg-header">
      <app-header></app-header>
    </header>
  }
  <div id="main-section">
    <main id="amg-content-region">
      <div id="content-inner">
        @if (showLanguageSelectionModal) {
          <app-language-selection></app-language-selection>
        }
        <app-loading-spinner></app-loading-spinner>
        <router-outlet></router-outlet>
      </div>
      @if (refSessionComAvailable) {
        <app-refresh-session></app-refresh-session>
      }

    </main>
    <!-- @if (isLoggedIn || isProfileAvailable) {
      <footer id="amg-footer">
        <app-footer></app-footer>
      </footer>
    } -->
  </div>
</div>